import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class DepositorDetailsService {

  constructor(private httpService: HttpService) { }


  // ///////////////////////////////////////////////
  // add depositor details
  depositorData(depositorDataObject) {
    var request = {
      URL: 'depositorDetails/adddepositorData',
      DATA: depositorDataObject
    }
    return this.httpService.post(request);
  }

  // get depositor details by Id
  getDepositor(_id) {
    var request = {
      URL: "depositorDetails/getDepositorDetailsById/" + _id
    }
    return this.httpService.get(request);
  }

  // update depositor details
  updateDepositorData(depositorDataObject, _id) {
    var request = {
      URL: 'depositorDetails/updateDepositorData/' + _id,
      DATA: depositorDataObject
    }
    return this.httpService.post(request);
  }

  // ///////////////////////////////////////////////

  // add regulatory details
  regulatoryData(regulatoryObject) {
    var request = {
      URL: 'depositorDetails/addregulatoryData',
      DATA: regulatoryObject
    }
    return this.httpService.post(request);
  }

  // ///////////////////////////////////////////////

  // get deposits details list
  getDepositDetails(_id, searchParam) {
    var request = {
      URL: "depositorDetails/getDepositDetails/" + _id,
      DATA: searchParam
    }
    return this.httpService.post(request);
  }
  // delete deposits details
  removeDepositDetails(depositId, _id) {
    var request = {
      URL: "depositorDetails/deleteDepositDetails/" + _id +"/" + depositId
    }
    return this.httpService.get(request);
  }

  update(_id, data) {
    var request = {
      URL: "depositorDetails/depositor-details/" + _id,
      DATA: data
    }
    return this.httpService.post(request);
  }


  // depositor list
  getDepositorlistDetail(object) {
    var request = {
      URL: "depositorDetails/getDepositorlistDetail",
      DATA: object
    }
    return this.httpService.post(request);
  }

  removeDepositor(_id) {
    var request = {
      URL: "depositorDetails/deleteDepositorlist/" + _id
    }
    return this.httpService.get(request);
  }

 // add deposits details
  addDepositsDetail(detailsOfDeposit) {
    var request = {
        URL: "depositorDetails/addDepositsDetail",
        DATA: detailsOfDeposit
    }
    return this.httpService.post(request);

}

updateDetailsOfDeposit(object) {
  var request = {
      URL: "depositorDetails/updateDetailsOfDeposit",
      DATA: object
  }
  return this.httpService.post(request);
}


generateDepositorDetailsDocument(object) {
  var request = {
      URL: "depositorDetails/generateDepositorDetailsDocument",
      DATA: object
  }
  return this.httpService.post(request);
}

downloadDepositorDetailsFile(id, type) {
  var token = localStorage.getItem('token')
  window.location.href = environment.pssServerUrl + "depositorDetails/downloadDocument/" + id + "/" + type + "/" + token;
}

downloadDepositorDetailsPdfFile(id, type) {
  var token = localStorage.getItem('token')
  window.location.href = environment.pssServerUrl + "depositorDetails/downloadPdfDocument/" + id + "/" + type + "/" + token;
}


}
